import Logo from '../logos/virtualhousesim';

export default Logo;
